// extracted by mini-css-extract-plugin
export default {"DayMode":"styles_DayMode__qTkwH","date":"styles_date__zSRTc","day":"styles_day__A-aBU","today":"styles_today__VD6rR","buttons":"styles_buttons__tzvaF"};